import Vue from 'vue';
import App from './App';
import router from './router';
import Loading from '@/components/global/loading';
import Toast from '@/components/global/toast';
// import "./styles/reset.css";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Vconsole from 'vconsole';
import { isDev } from './config';

Vue.use(VueAwesomeSwiper)

Vue.prototype.globalData = {
  isVip: false,
  info: []
}
if (isDev) {
  const vConsole = new Vconsole();
  Vue.use(vConsole);
}

Vue.config.productionTip = false;
Vue.use(Loading);
Vue.use(Toast);
new Vue({
  render: h => h(App),
  router
}).$mount('#app');
